<div class="portlet light">
  <div class="portlet-body">
    <ng-container>
      <table class="tableContent table" #counter *ngrxLet="sharedService.startTourObs$ as isTourOn">
        <thead>
          <tr>
            <th id="personal-header-content">
              <div>
                <span class="caption-subject">Personal achievements</span>
              </div>
            </th>
            <th [width]="500" id="toggle-header-content">
              <div>
                <div class="toggle-darkswitch checkBoxAlienMent">
                  <span class="toggleText"
                    >Use the toggle to the right to see <br />
                    your personal achievements</span
                  >
                  <div class="rightArrow"><i class="bi bi-arrow-right"></i></div>
                  <div class="form-check form-switch switch-custom">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      [(ngModel)]="isTourOn[0] ? true : showAchievements"
                      (change)="toggleAchievements(showAchievements)"
                    />
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <ng-container *ngIf="isTourOn[0] ? true : showAchievements">
          <thead>
            <tr style="text-align: start">
              <th></th>
              <th [width]="500">Personal achievements</th>
            </tr>
          </thead>
          <hr class="dividerstatic" />

          <tr class="titletext">
            <td class="projecttd">No. of projects</td>
            <td class="statstext counter counter-1">
              {{ getglobalsavingsData.totalProjectOfUser }}
            </td>
          </tr>
          <hr class="dividerstatic" />

          <tr class="titletext scenarios">
            <td class="projecttd">Number of scenarios</td>
            <td
              class="statstext counter counter-3"
              id="scenarioCount"
              [joyrideStep]="stepCount"
              [stepPosition]="'left'"
              (next)="onNext()"
              [title]="stepTitle"
              [text]="stepText"
            >
              {{ getglobalsavingsData.totalProjectScenarioOfUser }}
            </td>
          </tr>
        </ng-container>
      </table>
    </ng-container>
  </div>
</div>
